var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    zoomAndPan: "magnify",
    viewBox: "0 0 300 299.999988",
    height: 400,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b418d1c227"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79 2 L 245 2 L 245 298 L 79 298 Z M 79 2 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0a9db106fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.851562 299.992188 L -53.003906 162.710938 L 84.277344 -0.148438 L 247.136719 137.136719 Z M 109.851562 299.992188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8f774f32c8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.851562 299.992188 L -53.003906 162.710938 L 84.277344 -0.148438 L 247.136719 137.136719 Z M 109.851562 299.992188 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b418d1c227)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a9db106fd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8f774f32c8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 88.65625 3.542969 L 242.757812 133.445312 C 245.179688 135.488281 245.488281 139.089844 243.445312 141.511719 L 113.542969 295.613281 C 111.5 298.039062 107.894531 298.34375 105.472656 296.300781 C 103.050781 294.261719 102.746094 290.65625 104.785156 288.234375 L 231 138.511719 L 81.273438 12.296875 C 78.851562 10.257812 78.546875 6.652344 80.585938 4.230469 C 82.628906 1.808594 86.234375 1.5 88.65625 3.542969 Z M 88.65625 3.542969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleIcon);
export default __webpack_public_path__ + "static/media/angle-icon.b25883e0407995cc201c1a7e0fc0d79d.svg";
export { ForwardRef as ReactComponent };